import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('size-guide-popup')
class SizeGuidePopup extends LitElement {
  connectedCallback() {
    super.connectedCallback();
    this._initSizeChart();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.sizeChartTrigger?.removeEventListener(
      'click',
      this._handleSizeChartClick,
    );
    this.closeSizeChartButton?.removeEventListener(
      'click',
      this._handleCloseSizeChartClick,
    );
  }

  _initSizeChart = () => {
    this.sizeChartTrigger = this.querySelector('[data-size-chart-trigger]');
    if (!this.sizeChartTrigger) return;

    this.sizeChartPopUp = this.querySelector('[data-size-chart-pop-up]');
    this.sizeChartHTMLContainers = document.querySelectorAll(
      '[data-size-chart-html-container]',
    );
    this.closeSizeChartButton = this.querySelector(
      '[data-close-size-chart-button]',
    );

    this._formatSizeChartHTML();
    this.sizeChartTrigger.addEventListener('click', this._handleSizeChartClick);
    this.closeSizeChartButton.addEventListener(
      'click',
      this._handleCloseSizeChartClick,
    );
  };

  _formatSizeChartHTML = () => {
    if (!this.sizeChartHTMLContainers.length) return;

    this.sizeChartHTMLContainers.forEach((container) => {
      container.querySelectorAll('style').forEach((tag) => {
        tag.remove();
      });
    });
  };

  _handleSizeChartClick = () => {
    this.sizeChartPopUp.classList.remove('hidden');
  };

  _handleCloseSizeChartClick = () => {
    this.sizeChartPopUp.classList.add('hidden');
  };

  render() {
    return html`<slot></slot>`;
  }
}

export default SizeGuidePopup;
